"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupplProvisionAppdxItemTitle = exports.supplProvisionAppdxItemTitleTags = exports.isSupplProvisionAppdxItem = exports.supplProvisionAppdxItemTags = exports.isAppdxItemTitle = exports.appdxItemTitleTags = exports.isAppdxItem = exports.appdxItemTags = exports.isNoteLikeStructTitle = exports.noteLikeStructTitleTags = exports.isNoteLikeStruct = exports.noteLikeStructTags = exports.isNoteLike = exports.noteLikeTags = exports.isListOrSublistSentence = exports.listOrSublistSentenceTags = exports.isListOrSublist = exports.listOrSublistTags = exports.isTOCItem = exports.tocItemTags = exports.isTOCArticleGroup = exports.tocArticleGroupTags = exports.isArticleGroupTitle = exports.articleGroupTitleTags = exports.isArticleGroup = exports.articleGroupTags = exports.articleGroupTypeChars = exports.typeCharsMap = exports.listTags = exports.isParagraphItemSentence = exports.paragraphItemSentenceTags = exports.isParagraphItemTitle = exports.paragraphItemTitleTags = exports.isParagraphItem = exports.paragraphItemTags = exports.eras = exports.Era = void 0;
var Era;
(function (Era) {
    Era["Meiji"] = "Meiji";
    Era["Taisho"] = "Taisho";
    Era["Showa"] = "Showa";
    Era["Heisei"] = "Heisei";
    Era["Reiwa"] = "Reiwa";
})(Era || (exports.Era = Era = {}));
exports.eras = {
    "明治": Era.Meiji, "大正": Era.Taisho,
    "昭和": Era.Showa, "平成": Era.Heisei,
    "令和": Era.Reiwa,
};
exports.paragraphItemTags = [
    "Paragraph",
    "Item",
    "Subitem1",
    "Subitem2",
    "Subitem3",
    "Subitem4",
    "Subitem5",
    "Subitem6",
    "Subitem7",
    "Subitem8",
    "Subitem9",
    "Subitem10",
];
const isParagraphItem = (el) => typeof el !== "string" && exports.paragraphItemTags.includes(el.tag);
exports.isParagraphItem = isParagraphItem;
exports.paragraphItemTitleTags = [
    "ParagraphNum",
    "ItemTitle",
    "Subitem1Title",
    "Subitem2Title",
    "Subitem3Title",
    "Subitem4Title",
    "Subitem5Title",
    "Subitem6Title",
    "Subitem7Title",
    "Subitem8Title",
    "Subitem9Title",
    "Subitem10Title",
];
const isParagraphItemTitle = (el) => typeof el !== "string" && exports.paragraphItemTitleTags.includes(el.tag);
exports.isParagraphItemTitle = isParagraphItemTitle;
exports.paragraphItemSentenceTags = [
    "ParagraphSentence",
    "ItemSentence",
    "Subitem1Sentence",
    "Subitem2Sentence",
    "Subitem3Sentence",
    "Subitem4Sentence",
    "Subitem5Sentence",
    "Subitem6Sentence",
    "Subitem7Sentence",
    "Subitem8Sentence",
    "Subitem9Sentence",
    "Subitem10Sentence",
];
const isParagraphItemSentence = (el) => typeof el !== "string" && exports.paragraphItemSentenceTags.includes(el.tag);
exports.isParagraphItemSentence = isParagraphItemSentence;
exports.listTags = ["List", "Sublist1", "Sublist2", "Sublist3"];
exports.typeCharsMap = {
    "法": "Law",
    "編": "Part", "章": "Chapter", "節": "Section", "款": "Subsection", "目": "Division",
    "条": "Article", "項": "Paragraph", "号": "Item",
    "則": "SupplProvision",
};
exports.articleGroupTypeChars = ["編", "章", "節", "款", "目"];
exports.articleGroupTags = [
    "Part",
    "Chapter",
    "Section",
    "Subsection",
    "Division",
];
const isArticleGroup = (el) => typeof el !== "string" && exports.articleGroupTags.includes(el.tag);
exports.isArticleGroup = isArticleGroup;
exports.articleGroupTitleTags = [
    "PartTitle",
    "ChapterTitle",
    "SectionTitle",
    "SubsectionTitle",
    "DivisionTitle",
];
const isArticleGroupTitle = (el) => typeof el !== "string" && exports.articleGroupTitleTags.includes(el.tag);
exports.isArticleGroupTitle = isArticleGroupTitle;
exports.tocArticleGroupTags = [
    "TOCPart",
    "TOCChapter",
    "TOCSection",
    "TOCSubsection",
    "TOCDivision",
];
const isTOCArticleGroup = (el) => typeof el !== "string" && exports.tocArticleGroupTags.includes(el.tag);
exports.isTOCArticleGroup = isTOCArticleGroup;
exports.tocItemTags = [
    ...exports.tocArticleGroupTags,
    "TOCPreambleLabel",
    "TOCArticle",
    "TOCSupplProvision",
    "TOCAppdxTableLabel",
];
const isTOCItem = (el) => typeof el !== "string" && exports.tocItemTags.includes(el.tag);
exports.isTOCItem = isTOCItem;
exports.listOrSublistTags = [
    "List",
    "Sublist1",
    "Sublist2",
    "Sublist3",
];
const isListOrSublist = (el) => typeof el !== "string" && exports.listOrSublistTags.includes(el.tag);
exports.isListOrSublist = isListOrSublist;
exports.listOrSublistSentenceTags = [
    "ListSentence",
    "Sublist1Sentence",
    "Sublist2Sentence",
    "Sublist3Sentence",
];
const isListOrSublistSentence = (el) => typeof el !== "string" && exports.listOrSublistSentenceTags.includes(el.tag);
exports.isListOrSublistSentence = isListOrSublistSentence;
exports.noteLikeTags = [
    "Note",
    "Style",
    "Format",
];
const isNoteLike = (el) => typeof el !== "string" && exports.noteLikeTags.includes(el.tag);
exports.isNoteLike = isNoteLike;
exports.noteLikeStructTags = [
    "NoteStruct",
    "StyleStruct",
    "FormatStruct",
];
const isNoteLikeStruct = (el) => typeof el !== "string" && exports.noteLikeStructTags.includes(el.tag);
exports.isNoteLikeStruct = isNoteLikeStruct;
exports.noteLikeStructTitleTags = [
    "NoteStructTitle",
    "StyleStructTitle",
    "FormatStructTitle",
];
const isNoteLikeStructTitle = (el) => typeof el !== "string" && exports.noteLikeStructTitleTags.includes(el.tag);
exports.isNoteLikeStructTitle = isNoteLikeStructTitle;
exports.appdxItemTags = [
    "AppdxFig",
    "AppdxStyle",
    "AppdxFormat",
    "AppdxTable",
    "AppdxNote",
    "Appdx",
];
const isAppdxItem = (el) => typeof el !== "string" && exports.appdxItemTags.includes(el.tag);
exports.isAppdxItem = isAppdxItem;
exports.appdxItemTitleTags = [
    "AppdxFigTitle",
    "AppdxStyleTitle",
    "AppdxFormatTitle",
    "AppdxTableTitle",
    "AppdxNoteTitle",
    "ArithFormulaNum",
];
const isAppdxItemTitle = (el) => typeof el !== "string" && exports.appdxItemTitleTags.includes(el.tag);
exports.isAppdxItemTitle = isAppdxItemTitle;
exports.supplProvisionAppdxItemTags = [
    "SupplProvisionAppdxTable",
    "SupplProvisionAppdxStyle",
    "SupplProvisionAppdx",
];
const isSupplProvisionAppdxItem = (el) => typeof el !== "string" && exports.supplProvisionAppdxItemTags.includes(el.tag);
exports.isSupplProvisionAppdxItem = isSupplProvisionAppdxItem;
exports.supplProvisionAppdxItemTitleTags = [
    "SupplProvisionAppdxTableTitle",
    "SupplProvisionAppdxStyleTitle",
    "ArithFormulaNum",
];
const isSupplProvisionAppdxItemTitle = (el) => typeof el !== "string" && exports.supplProvisionAppdxItemTitleTags.includes(el.tag);
exports.isSupplProvisionAppdxItemTitle = isSupplProvisionAppdxItemTitle;
//# sourceMappingURL=helpers.js.map